import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { accessControlProfilesKeys } from '../../api/query-keys/access-control-profiles';
import { AccessControlProfile } from '../../api/types/access-control-profile';

import { destinationsApi } from '@/features/destinations/api/lib/destinations';

export const useAccessControlProfiles = () => {
  return useQuery<AccessControlProfile[], ApiError>({
    queryKey: accessControlProfilesKeys.list(),
    queryFn: destinationsApi.fetchAccessControlProfiles,
  });
};
